module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_inbound-08266c0f33e2319e8c3cee6fcd500a7c.svg";